export class MinValueError extends Error {
  constructor (minValue: number) {
    super(`O valor mínimo deve ser de ${minValue.toLocaleString('pt-BR')}`)
    this.name = 'MinValueError'
  }
}
